import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  key: 0,
  disabled: "",
  value: ""
}
const _hoisted_3 = ["value"]

import { ref } from "vue";
import commonProps from "../props/commonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputSelect2',
  props: commonProps,
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const selectedOption = ref({ value: "", text: "" });


const emit = __emit;

const onInput = (event: Event) => {
  const target = event.target as HTMLSelectElement;

  selectedOption.value = {
    value: target.value,
    text: target.options[target.selectedIndex].text,
  };

  emit("update:modelValue", selectedOption.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$attrs.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass({ required: _ctx.$attrs.required })
        }, _toDisplayString(_ctx.$attrs.label), 3))
      : _createCommentVNode("", true),
    _createElementVNode("select", _mergeProps({
      class: "form-select form-control",
      value: _ctx.modelValue.value
    }, {
        ..._ctx.$attrs,
        onChange: onInput,
      }), [
      (_ctx.$attrs.showEmptyOption !== false)
        ? (_openBlock(), _createElementBlock("option", _hoisted_2, _toDisplayString(_ctx.$attrs.placeholder || "Selecione uma das Opções"), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, ({ value, label }, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          value: value
        }, _toDisplayString(label), 9, _hoisted_3))
      }), 128))
    ], 16, _hoisted_1)
  ]))
}
}

})